import type { BoligTypePrivat, BoligTypeSelskap } from "@/api/generated";

export class Constants {
  static readonly PRIVAT_BOLIGTYPER = [
    "Bolig",
    "Fritidsbolig",
  ] as const satisfies readonly BoligTypePrivat[];
  static readonly SELSKAPS_BOLIGTYPER = [
    "Boligselskap",
    "BoligselskapFritid",
    "Andre",
  ] as const satisfies readonly BoligTypeSelskap[];
}
